// Page: reset-password  (forgot-password + reset-password, one module)
//
// Ported from the two inline <script> blocks in
//   Enrollment_modules/reset-password/form.module/module.html.
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes,
// consistent with the pilot (docs/handoff/global-js-deep-refactor-notes.md):
//   1. Selectors scoped to the HubSpot render-time wrapper id
//      `#page_0_returning_user_widget` are now scoped to `root` (the element
//      carrying data-ea-module). Page-global selectors (the overlay/loader ids
//      read via getElementById, and the #ResetPassFormMain/#ForgotPassFormMain
//      display toggle, and the #HubspotMailForm jQuery form) stay document-scoped.
//   2. `_hcms/api/*` fetches and same-origin JS redirects are ROOT-RELATIVE
//      (via core/api `apiUrl`) instead of hardcoding https://enrollment.nautilussolar.com.
//   3. `validatePass` is imported from ui/validation (was the temporary window shim).
//   4. The reset link written into the HubSpot email form is built from
//      window.location.origin (was the hardcoded production host) so it points at
//      whichever portal served the page — the only faithful, portable equivalent
//      for an absolute link that must survive into an email.
//
// `crypt` (crypto-js) is still provided by the crypto-js CDN + `var crypt` glue
// script left in module.html; it is declared ambiently in global.d.ts.

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { validatePass } from "../../ui/validation"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/account/reset-password.ts","init",[root,_config],["root","_config"]);
  const q = (sel: string) => root.querySelector(sel) as HTMLElement
  const qi = (sel: string) => root.querySelector(sel) as HTMLInputElement
  const di = (id: string) => document.getElementById(id) as HTMLElement

  let responseFromAPI: any = ""

  // ─── Loaders (page-global overlays) ───────────────────────────────────────────
  function RPOpenLoader(): void {
__ea_trace("modules/account/reset-password.ts","RPOpenLoader",[],[]);
    const loader = di("resetPassLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("RPloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }
  function RPcloseLoader(): void {
__ea_trace("modules/account/reset-password.ts","RPcloseLoader",[],[]);
    const loader = di("resetPassLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("RPloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = false
    })
  }
  function passUpdatedOpenLoader(): void {
__ea_trace("modules/account/reset-password.ts","passUpdatedOpenLoader",[],[]);
    const loader = di("PassUpdatedresetPassLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("PassUpdatedloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }

  // ─── Reset-password (new + confirm) ───────────────────────────────────────────
  function validateNewPassword(): void {
__ea_trace("modules/account/reset-password.ts","validateNewPassword",[],[]);
    q("#RPuserNotExist").innerHTML = ""
    const password = qi("#NewForgotpassword").value
    const validPassword = validatePass(password)
    if (validPassword.valid) {
      q("#NewFP-password_error_message").innerHTML = ""
    } else {
      q("#NewFP-password_error_message").innerHTML = validPassword.errors[0]
    }
  }

  function validateConfirmPassword(): void {
__ea_trace("modules/account/reset-password.ts","validateConfirmPassword",[],[]);
    q("#RPuserNotExist").innerHTML = ""
    const password = qi("#ConfirmForgotpassword").value
    const validPassword = validatePass(password)
    if (validPassword.valid) {
      q("#ConfirmFP-password_error_message").innerHTML = ""
    } else {
      q("#ConfirmFP-password_error_message").innerHTML = validPassword.errors[0]
    }
  }

  function validateNCForm(): boolean {
__ea_trace("modules/account/reset-password.ts","validateNCForm",[],[]);
    q("#RPuserNotExist").innerHTML = ""
    validateNewPassword()
    validateConfirmPassword()

    const errorMessages = root.querySelectorAll(".FP-error-message")
    let hasErrors = false
    for (let i = 0; i < errorMessages.length; i++) {
      if (errorMessages[i].innerHTML !== "") {
        hasErrors = true
        break
      }
    }
    if (hasErrors) {
      return false
    } else {
      const npw = qi("#NewForgotpassword").value.trim()
      const cnpw = qi("#ConfirmForgotpassword").value.trim()
      if (npw === cnpw) {
        FPUpdatePassword()
        return true
      } else {
        q("#RPuserNotExist").innerHTML = "The passwords entered do not match. Please try again"
      }
    }
    return false
  }

  // Defined but unused in the original inline script — kept faithfully.
  const errorCount = 0
  void errorCount
  function dcryptEmail(): void {
__ea_trace("modules/account/reset-password.ts","dcryptEmail",[],[]);}
  void dcryptEmail

  async function FPUpdatePassword(): Promise<boolean> {
__ea_trace("modules/account/reset-password.ts","FPUpdatePassword",[],[]);
    const currentUrl = window.location.href
    const parts = currentUrl.split("?")
    let firstPart = parts[1].split("&")[0]
    firstPart = decodeURIComponent(firstPart)
    const dEmail = crypt.decrypt(firstPart)
    let email = dEmail
    email = email.toLowerCase()
    let password = qi("#NewForgotpassword").value
    password = crypt.encrypt(password)
    RPOpenLoader()
    let catchdata: any = ""
    try {
      const data = { properties: { email: email, password: password } }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        RPcloseLoader()
        passUpdatedOpenLoader()
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      RPcloseLoader()
      console.error("Error:", error)
    }
    return true
  }

  async function GetDataFromDealRecord(email: string): Promise<void> {
__ea_trace("modules/account/reset-password.ts","GetDataFromDealRecord",[email],["email"]);
    let catchdata: any = ""
    try {
      const data = { deal_email_test: email }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
        await getContactRecord(email)
      } else if (dataa.message === "User Found") {
        RPcloseLoader()
        passUpdatedOpenLoader()
      }
    } catch (error) {
      RPcloseLoader()
      passUpdatedOpenLoader()
      console.error("Error:", error)
    }
  }
  void GetDataFromDealRecord

  async function getContactRecord(email: string): Promise<void> {
__ea_trace("modules/account/reset-password.ts","getContactRecord",[email],["email"]);
    let catchdata: any = ""
    try {
      const data = { email: email }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = dataa
      const recordId = dataa.userValue.properties.hs_object_id
      catchdata = ""
      try {
        const data = { contactId: recordId }
        const response = await fetch(apiUrl("FetchAssociatedDealsBasedOnContactId"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        })
        catchdata = data
        const dataa = await response.json()
        responseFromAPI = JSON.stringify(dataa)
        const dealRecordLength = dataa.userValue.associations.deals.results.length
        if (dealRecordLength === 0) {
          RPcloseLoader()
          passUpdatedOpenLoader()
        } else {
          RPcloseLoader()
          passUpdatedOpenLoader()
        }
      } catch (error) {
        RPcloseLoader()
        console.error("Error:", error)
      }
    } catch (error) {
      RPcloseLoader()
      passUpdatedOpenLoader()
      console.error("Error:", error)
    }
  }

  async function createDealRecord(contactId: any, emaill: any): Promise<void> {
__ea_trace("modules/account/reset-password.ts","createDealRecord",[contactId,emaill],["contactId","emaill"]);
    const cntId = `New Enrollment - ${contactId}`
    let catchdata: any = ""
    try {
      const dataa = {
        properties: {
          deal_email_test: emaill,
          dealname: cntId,
          dealstage: "157471033",
        },
      }
      const response = await fetch(apiUrl("AddDealRecord"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataa),
      })
      catchdata = dataa
      const dealResult = await response.json()
      responseFromAPI = JSON.stringify(dealResult)
      const dealId = dealResult.id
      if (response.status === 200) {
        await dealAssociateWithContact(contactId, dealId, emaill)
      }
    } catch (error) {
      RPcloseLoader()
      passUpdatedOpenLoader()
      console.error("Error:", error)
    }
  }
  void createDealRecord

  async function dealAssociateWithContact(contactId: any, dealId: any, emailll: any): Promise<void> {
__ea_trace("modules/account/reset-password.ts","dealAssociateWithContact",[contactId,dealId,emailll],["contactId","dealId","emailll"]);
    void emailll
    let catchdata: any = ""
    try {
      const dataaa = {
        inputs: [{ from: { id: contactId }, to: { id: dealId } }],
      }
      const response = await fetch(apiUrl("DealAssociateWithContact"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataaa),
      })
      catchdata = dataaa
      if (response.status === 200) {
        RPcloseLoader()
        passUpdatedOpenLoader()
      }
      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      RPcloseLoader()
      passUpdatedOpenLoader()
      console.error("Error:", error)
    }
  }

  // Kept faithfully: defined in the original inline script; only external/onclick
  // callers (if any) reference them.
  let pwd: any
  void pwd
  function dp(val: string): void {
__ea_trace("modules/account/reset-password.ts","dp",[val],["val"]);
    pwd = crypt.decrypt(val)
  }
  void dp

  // ─── Forgot-password (email → send reset link) ────────────────────────────────
  function emailSendOpenLoader(): void {
__ea_trace("modules/account/reset-password.ts","emailSendOpenLoader",[],[]);
    const loader = di("emailSendLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("emailSendOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }
  function emailSendcloseLoader(): void {
__ea_trace("modules/account/reset-password.ts","emailSendcloseLoader",[],[]);
    const loader = di("emailSendLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("emailSendOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = false
    })
  }
  function returningUserOpenLoader(): void {
__ea_trace("modules/account/reset-password.ts","returningUserOpenLoader",[],[]);
    const loader = di("returningUserLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("RUloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = true
    })
  }
  function returningUsercloseLoader(): void {
__ea_trace("modules/account/reset-password.ts","returningUsercloseLoader",[],[]);
    const loader = di("returningUserLoader")
    const buttons = document.querySelectorAll("button")
    const anchors = document.querySelectorAll("a")
    di("RUloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as unknown as HTMLButtonElement).disabled = false
    })
  }

  function validateFPEmail(): void {
__ea_trace("modules/account/reset-password.ts","validateFPEmail",[],[]);
    q("#FPuserNotExist").innerHTML = ""
    const email = qi("#FP-email").value.trim()
    if (email === "") {
      q("#FP-email_error_message").innerHTML = "Please enter your Email Id."
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      q("#FP-email_error_message").innerHTML = "Please enter a valid email address."
    } else {
      q("#FP-email_error_message").innerHTML = ""
    }
  }

  function validateFPForm(): boolean {
__ea_trace("modules/account/reset-password.ts","validateFPForm",[],[]);
    q("#FPuserNotExist").innerHTML = ""
    validateFPEmail()
    const errorMessages = root.querySelectorAll(".FPE-error-message")
    let hasErrors = false
    for (let i = 0; i < errorMessages.length; i++) {
      if (errorMessages[i].innerHTML !== "") {
        hasErrors = true
        break
      }
    }
    if (hasErrors) {
      return false
    } else {
      FPCheckIfUserExist()
      return true
    }
  }

  async function sendDataToForm(email: string, enValue: string): Promise<void> {
__ea_trace("modules/account/reset-password.ts","sendDataToForm",[email,enValue],["email","enValue"]);
    $("#HubspotMailForm form .hs_email input").val(email)
    enValue = encodeURIComponent(enValue)
    // Portable equivalent of the original hardcoded production host: the emailed
    // reset link must be absolute, so it is built from the serving portal's origin.
    $("#HubspotMailForm form .hs_encrypted_email input").val(`${window.location.origin}/reset-password?${enValue}`)
    $("#HubspotMailForm form .hs_submit input").trigger("click")
    returningUsercloseLoader()
    emailSendOpenLoader()
    setTimeout(emailSendcloseLoader, 10000)
  }

  async function FPCheckIfUserExist(): Promise<void> {
__ea_trace("modules/account/reset-password.ts","FPCheckIfUserExist",[],[]);
    let email = qi("#FP-email").value
    email = email.toLowerCase()
    const encryptEmail = crypt.encrypt(email)
    let catchdata: any = ""
    try {
      returningUserOpenLoader()
      const data = { email: email }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
        returningUsercloseLoader()
        q("#FPuserNotExist").innerHTML =
          'A user with this email address does not exist. Please try again or contact customer support at <a href="tel:+18669694129">18669694129</a>'
      } else if (dataa.message === "User Found") {
        await sendDataToForm(email, encryptEmail)
      }
    } catch (error) {
      returningUsercloseLoader()
      q("#FPuserNotExist").innerHTML =
        'A user with this email address does not exist. Please try again or contact customer support at <a href="tel:+18669694129">18669694129</a>'
      console.error("Error:", error)
    }
  }

  // ─── Wiring (was top-level in the inline scripts) ─────────────────────────────
  q("#LBFFP").addEventListener("click", () => {
__ea_trace("modules/account/reset-password.ts","(anon)",[],[]);
    window.location.href = "/?rupapr"
  })

  qi("#NewForgotpassword").addEventListener("input", validateNewPassword)
  qi("#ConfirmForgotpassword").addEventListener("input", validateConfirmPassword)
  qi("#NewForgotpassword").addEventListener("keypress", (event) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[event],["event"]);
    if (event.key === "Enter") {
      validateNewPassword()
    }
  })
  qi("#ConfirmForgotpassword").addEventListener("keypress", (event) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[event],["event"]);
    if (event.key === "Enter") {
      validateConfirmPassword()
    }
  })
  q("#rs_submit").addEventListener("click", validateNCForm)

  const togglePassword = q("#NewFPtogglePassword")
  const password = qi("#NewForgotpassword")
  togglePassword.addEventListener("click", function (this: HTMLElement) {
__ea_trace("modules/account/reset-password.ts","(anon)",[this],["this"]);
    const type = password.getAttribute("type") === "password" ? "text" : "password"
    password.setAttribute("type", type)
    this.classList.toggle("fa-eye-slash")
  })
  $(root)
    .find("form i#NewFPtogglePassword")
    .on("click", function (this: HTMLElement) {
__ea_trace("modules/account/reset-password.ts","(anon)",[this],["this"]);
      $(this).toggleClass("colored")
    })

  const fpptogglePassword = q("#ConfirmFPtogglePassword")
  const fppassword = qi("#ConfirmForgotpassword")
  fpptogglePassword.addEventListener("click", function (this: HTMLElement) {
__ea_trace("modules/account/reset-password.ts","(anon)",[this],["this"]);
    const type = fppassword.getAttribute("type") === "password" ? "text" : "password"
    fppassword.setAttribute("type", type)
    this.classList.toggle("fa-eye-slash")
  })
  $(root)
    .find("form i#ConfirmFPtogglePassword")
    .on("click", function (this: HTMLElement) {
__ea_trace("modules/account/reset-password.ts","(anon)",[this],["this"]);
      $(this).toggleClass("colored")
    })

  // Initial view: reset form when a query string is present (from the email
  // link), otherwise the forgot-password form.
  const currentUrll = window.location.href
  const parts = currentUrll.split("?")
  if (parts[1]) {
    ;(document.querySelector("#ForgotPassFormMain") as HTMLElement).style.display = "none"
    ;(document.querySelector("#ResetPassFormMain") as HTMLElement).style.display = "block"
  } else {
    ;(document.querySelector("#ResetPassFormMain") as HTMLElement).style.display = "none"
    ;(document.querySelector("#ForgotPassFormMain") as HTMLElement).style.display = "block"
  }

  qi("#FP-email").addEventListener("input", validateFPEmail)
  q("#fp_submit").addEventListener("click", validateFPForm)
  qi("#FP-email").addEventListener("keypress", (event) => {
__ea_trace("modules/account/reset-password.ts","(anon)",[event],["event"]);
    if (event.key === "Enter") {
      validateFPForm()
    }
  })
}
